'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.now = now;
function now() {
  return typeof performance !== 'undefined' && performance && performance.now ? performance.now() : -1;
}
//# sourceMappingURL=performance.js.map



//////////////////
// WEBPACK FOOTER
// ./~/web-bi-logger/dist/src/lib/performance.js
// module id = 1123
// module chunks = 15 16 17 18 19